import { MessageCircle, X } from "lucide-react";
import styles from "./SupportChat.module.css"; // Assuming you have a CSS module for styles
const ChatBubble = ({ isOpen, onClick, hasUnread = false }) => {
  return (
    <button
      onClick={onClick}
      className={`
        ${styles.chatBubble}
        ${isOpen ? styles.isOpen : styles.isClosed}`}
    >
      <div className={styles.chatBubbleInner}>
        {isOpen ? (
          <X className={styles.chatBubbleIcon} />
        ) : (
          <>
            <MessageCircle className={styles.chatBubbleIcon} />
            {hasUnread && <span className={styles.unread}></span>}
          </>
        )}
      </div>
    </button>
  );
};

export default ChatBubble;
